import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-faq-page',
  templateUrl: './faq-page.component.html',
  styleUrls: ['./faq-page.component.scss'],
})
export class FaqPage implements OnInit {

  constructor(private router : Router ) { }

  ngOnInit() {}
  gotohome() {
    this.router.navigate(['/patient']);
  }

}
